/** One Bootstrap icon per runtime primitive, so a type reads before its name does. */
export const OBJECTIVE_ICONS: Record<string, string> = {
  clear_area: 'crosshair',
  destroy_installation: 'fire',
  capture_hvt: 'person-badge',
  rescue_hostage: 'person-plus',
  defend_position: 'shield-shaded',
  escort_convoy: 'truck',
  clear_route: 'cone-striped',
  retrieve_intel: 'file-earmark-lock',
  defuse_bomb: 'x-octagon',
  deliver_supplies: 'box-seam',
  humanitarian_aid: 'heart-pulse',
  ambush_convoy: 'signpost-split',
  ambush_reaction: 'exclamation-triangle',
  sabotage_vehicles: 'wrench-adjustable',
  exfiltrate: 'airplane',
  bribe_informant: 'cash-coin',
};
